import { Component, _decorator } from 'cc';
import HistoryDetailData from '../../../../Data/DataObject/History/HistoryDetailData';
import NumberFormatter from '../../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import MultiThemeLabel from '../../../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeLabel';
import HistoryData from '../../../../Data/DataObject/History/HistoryData';

export enum StatusType {
    Playing,
    Finish,
    Cancel,
}

const { ccclass, property } = _decorator;

@ccclass('BaseHistoryDetailRecord')
export default class BaseHistoryDetailRecord extends Component {
    @property(MultiThemeLabel)
    protected readonly statusLabel: MultiThemeLabel = null;

    @property(NumberFormatter)
    protected readonly betNumber: NumberFormatter = null;

    @property(NumberFormatter)
    protected readonly winNumber: NumberFormatter = null;

    protected _historyData: HistoryData = null;
    protected _detailData: HistoryDetailData = null;

    public display(historyData: HistoryData): void {
        if (this._historyData === historyData) {
            return;
        }
        this._historyData = historyData;
        // this._detailData = detailData;
        this.updateContent();
    }

    protected updateContent(): void {
        this.statusLabel.theme = StatusType.Finish;
        // this.statusLabel.theme = this._historyData.isCanceled ? StatusType.Cancel : StatusType.Finish;
        this.betNumber.value = this._historyData.bet;
        this.winNumber.value = this._historyData.win;
    }
}
